var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatchLater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.564 8.963a.667.667 0 0 0-.82.465 5.311 5.311 0 0 1-3.398 3.608 5.284 5.284 0 0 1-4.071-.243A5.288 5.288 0 0 1 3.57 9.734a5.282 5.282 0 0 1 .246-4.068 5.29 5.29 0 0 1 3.051-2.704 5.324 5.324 0 0 1 5.65 1.417h-.711a.667.667 0 0 0 0 1.333h2.187a.667.667 0 0 0 .667-.667v-2.2a.667.667 0 1 0-1.333 0v.446a6.664 6.664 0 0 0-6.896-1.59 6.617 6.617 0 0 0-3.814 3.382 6.609 6.609 0 0 0-.307 5.086 6.612 6.612 0 0 0 3.38 3.823 6.625 6.625 0 0 0 5.091.305 6.647 6.647 0 0 0 4.248-4.514.667.667 0 0 0-.465-.82z",
    fill: "#7748FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.378 5.045a.667.667 0 0 0-.667.667v2.734c0 .234.123.451.324.572l2.117 1.267a.666.666 0 1 0 .684-1.145L9.044 8.068V5.712a.667.667 0 0 0-.666-.667z",
    fill: "#7748FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchLater);
export default __webpack_public_path__ + "static/media/dispatch_later.6e108e31a2af952bf710f1368b8e9c04.svg";
export { ForwardRef as ReactComponent };